
import { getSpecialNeeds } from "../../../dataGrid/cellRenderer";
import { getDriverStatus } from "../../../modules/Dispatch/RouteExecution/utils/DriverStatus";

const getNextStop = (stops) => {
  return stops.slice()
    .sort((stop1, stop2) => stop1.stopSequence - stop2.stopSequence)
    .find((stop) => !stop.isStopCompleted);
};

const getDeliveryStopContact = (stopData) => {
  return {
    name: stopData?.customerContactName ?? "",
    phoneNumber: stopData?.phoneNumber === "0" ? "" : stopData?.phoneNumber ?? "",
  };
};

const getPickupStopContact = (stopData) => {
  return {
    name: stopData?.shipperContactName ?? "",
    phoneNumber: stopData?.phoneNumber === "0" ? "" : stopData?.phoneNumber ?? "",
  };
};

const getDeliveryContent = (stopData) => {
  return [
    {
      labels: ["Spl Needs"],
      hasIconsListToRender: true,
      values: getSpecialNeeds({data: stopData}),
    },
    {
      labels: ["Bills"],
      values: [stopData.numberOfBills],
    },
    {
      labels: ["HU", "Weight"],
      values: [stopData.hu, stopData.weight ? `${stopData.weight} lbs` : "N/A"],
    },
    {
      labels: ["APT/Delivery Window"],
      values: [stopData.deliveryWindow],
    },
    {
      labels: ["ETA", "ETD"],
      values: [stopData.arrivalTime, stopData.departureTime],
    },
  ];
};

const getPickupContent = (stopData) => {
  return [
    {
      labels: ["Spl Needs"],
      hasIconsListToRender: true,
      values: getSpecialNeeds({data: stopData}),
    },
    {
      labels: ["HU", "Weight"],
      values: [stopData.hu, stopData.weight ? `${stopData.weight} lbs` : "N/A"],
    },
    {
      labels: ["Pieces"],
      values: [stopData.pieces],
    },
    {
      labels: ["Ready", "Close Time"],
      values: [stopData.readyTime, stopData.closeTime],
    },
    {
      labels: ["ETA", "ETD"],
      values: [stopData.arrivalTime, stopData.departureTime],
    },
  ];
};

const getTrailerContent = (trailerData) => {
  return [
    {
      labels: ["Trailer#"],
      values: [trailerData.trailerNumber],
    },
    {
      labels: ["Trailer Type"],
      values: [trailerData.trailerName],
    },
    {
      labels: ["Status"],
      values: [trailerData.trailerStatus],
    },
    {
      labels: ["Spotted by"],
      values: [`${trailerData.driverName} ${trailerData.driverNumber}`],
    },
    {
      labels: ["Spotted since"],
      values: [trailerData.spottedSince],
    },
  ];
};

const getDriverDetails = (routesData,  terminalOffset) => {
    const { driverStatus, driverStatusLabel } = getDriverStatus(
      { data: routesData, context: terminalOffset },
      false,
    );
    const stop = getNextStop(routesData.stops);
    return {
      driverName: routesData.driverName,
      driverNumber: routesData.driverNumber,
      driverId: routesData.driverId,
      nextStopDetails: stop
        ? {
            stopSequence: stop.stopSequence,
            stopName: stop.name,
            stopType: stop.stopType,
          }
        : null,
      driverStatusDetails: {
        driverStatus,
        driverStatusLabel,
      },
    };
  }

export {
  getNextStop,
  getDeliveryStopContact,
  getPickupStopContact,
  getPickupContent,
  getDeliveryContent,
  getDriverDetails,
  getTrailerContent,
};
